module.exports = __webpack_public_path__ + "img/poweredby.1f9d086d.svg";